import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CCol,
  CRow,
} from '@coreui/react-pro'
import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useAppDispatch, useTypedSelector } from '../../../../stateStore'
import { reduxServices } from '../../../../reducers/reduxServices'
import {
  conditionalDefaultStringEmpty,
  getItemNumber,
} from '../../../../utils/helper'
import StatusBadgeRenderer from '../CandidateListComponents/StatusBadgeRenderer'
import { NAstring } from '../../../../constant/constantData'
import OPageSizeSelectRevised from '../../../../components/ReusableComponent/OPageSizeSelectRevised'
import OPaginationRevised from '../../../../components/ReusableComponent/OPaginationRevised'

const CandidateInterviewListTable = (props: {
  currentPage: number
  pageSize: number
  reloadData: (pageSize: number, page: number) => void
  resetPagination: (identifier?: string) => void
}): JSX.Element => {
  const dispatch = useAppDispatch()
  const history = useHistory()

  const interviewCandidateList = useTypedSelector(
    reduxServices.candidateInterviewList.selectors.getInterviewCandidateList,
  )
  const listSize = useTypedSelector(
    reduxServices.candidateInterviewList.selectors
      .getInterviewCandidateListSize,
  )

  const nameLinkhandler = async (candidateId: number) => {
    const timeLineResultAction = await dispatch(
      reduxServices.intervieweeDetails.timeLineData(candidateId),
    )

    if (timeLineResultAction.payload === 403) {
      history.push('/forbidden')
    }
  }

  const handlePaginationConfigChange = (pageNumber: number, size: number) => {
    props.reloadData(size, pageNumber)
  }

  return (
    <div>
      <div
        className="candidate-interview-table-wrapper"
        style={{
          width: '100%',
          overflowX: 'auto',
          overflowY: 'hidden',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {/* Adding minWidth so horizontal scroll appears on narrow screens */}
        <CTable striped hover responsive={false} style={{ minWidth: '1100px' }}>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell>#</CTableHeaderCell>
              <CTableHeaderCell>Name</CTableHeaderCell>
              <CTableHeaderCell>Position Applied for</CTableHeaderCell>
              <CTableHeaderCell>Mobile</CTableHeaderCell>
              <CTableHeaderCell>Email ID</CTableHeaderCell>
              <CTableHeaderCell>Interview Round</CTableHeaderCell>
              <CTableHeaderCell>Experience</CTableHeaderCell>
              <CTableHeaderCell
                style={{
                  minWidth: '180px',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                }}
              >
                Skills
              </CTableHeaderCell>
              <CTableHeaderCell>Technology</CTableHeaderCell>
              <CTableHeaderCell>Recruiter</CTableHeaderCell>
              <CTableHeaderCell>Reference</CTableHeaderCell>
              <CTableHeaderCell>Country</CTableHeaderCell>
              <CTableHeaderCell>Status</CTableHeaderCell>
            </CTableRow>
          </CTableHead>

          <CTableBody>
            {interviewCandidateList?.length > 0 &&
              interviewCandidateList?.map((item, index) => {
                return (
                  <CTableRow key={index}>
                    <CTableDataCell>
                      {getItemNumber(index, props.currentPage, props.pageSize)}
                    </CTableDataCell>

                    <CTableDataCell>
                      <Link
                        to={`/candidatetimeline/${item?.personId}`}
                        className="cursor-pointer"
                        onClick={() => nameLinkhandler(Number(item?.personId))}
                      >
                        {item?.fullName}
                      </Link>
                    </CTableDataCell>

                    <CTableDataCell>{item?.postionvacant}</CTableDataCell>
                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(
                        item?.mobileNumber,
                        NAstring,
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(item?.email, NAstring)}
                    </CTableDataCell>

                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(
                        String(item?.interviewRound),
                        NAstring,
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(
                        String(item?.experiance),
                        NAstring,
                      )}
                    </CTableDataCell>

                    <CTableDataCell
                      style={{
                        whiteSpace: 'normal',
                        textAlign: 'left',
                        overflowWrap: 'break-word',
                        wordBreak: 'break-word',
                        maxWidth: '220px',
                      }}
                    >
                      {conditionalDefaultStringEmpty(item?.skills, NAstring)}
                    </CTableDataCell>

                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(
                        item?.technology,
                        NAstring,
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(item?.recruiter, NAstring)}
                    </CTableDataCell>

                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(
                        item?.sourceName,
                        NAstring,
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      {conditionalDefaultStringEmpty(item?.country, NAstring)}
                    </CTableDataCell>

                    <CTableDataCell>
                      {StatusBadgeRenderer(item?.interviewResultStatus, false)}
                    </CTableDataCell>
                  </CTableRow>
                )
              })}
          </CTableBody>
        </CTable>
      </div>

      {/* Pagination */}
      <CRow>
        <CCol lg={3} md={6}>
          <p className="mt-2">
            <strong>Total Records: {listSize}</strong>
          </p>
        </CCol>

        <CCol lg={3} md={6}>
          {listSize > 20 && (
            <OPageSizeSelectRevised
              changeCallback={handlePaginationConfigChange}
              options={[20, 40, 60, 80, 100]}
            />
          )}
        </CCol>

        {listSize > 20 && (
          <CCol
            lg={6}
            className="d-grid gap-1 d-md-flex justify-content-md-end"
          >
            <OPaginationRevised
              paginationChangeCallback={handlePaginationConfigChange}
            />
          </CCol>
        )}
      </CRow>
    </div>
  )
}

export default CandidateInterviewListTable
